import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { PageNotFoundComponent } from './home/page-not-found.component';
import { UserHomeComponent } from './home/user.home.component';
import { AppComponent } from './app.component';
import { UnAuthorizedAccessComponent } from './home/component/un-authorized-access.component';
import { UserAuthenticatedGuard } from './shared/guards/user-authenticated.guard';
import { ApplicantHomeComponent } from './home/applicant-home.component';

const routes: Routes = [
	{ path: 'home', component: HomeComponent, pathMatch: 'full' },
  { path: 'unauthorized', component: UnAuthorizedAccessComponent, pathMatch: 'full' },
  { path: 'applicant-home', component: ApplicantHomeComponent, pathMatch: 'full' },
  { path: 'user-home', component: UserHomeComponent, pathMatch: 'full' },
	{ path: 'applicants', loadChildren: () => import('./applicant/applicant.module').then(m => m.ApplicantModule) },
	{ path: 'users', loadChildren: () => import('./user/user.module').then(m => m.UserModule) },
  { path: 'applications', loadChildren: () => import('./application/application.module').then(m => m.ApplicationModule), canActivate: [UserAuthenticatedGuard] },
  { path: 'administration', loadChildren: () => import('./administration/administration.module').then(m => m.AdministrationModule), canActivate: [UserAuthenticatedGuard]},
  { path: 'reports', loadChildren: () => import('./report/report.module').then(m => m.ReportModule), canActivate: [UserAuthenticatedGuard]},
	{ path: '', redirectTo: 'home', pathMatch: 'full' },
	{ path: '**', component: PageNotFoundComponent }
];


@NgModule({
	declarations: [],
	imports: [
		RouterModule.forRoot(routes)
	],
	exports: [RouterModule]
})
export class AppRoutingModule {
  static components = [
    AppComponent,
    HomeComponent,
    ApplicantHomeComponent,
    UserHomeComponent,
    PageNotFoundComponent,
  ];
}
